import React from 'react';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import cloneDeep from 'lodash/cloneDeep';

import { Input, TextArea } from 'app/seedly-component-library';
import Button from 'app/seedly-component-library/button-new';

import { updateUserProfile } from 'app/dispatcher/profileDispatcher';

import ProfileCredentialsInputRow from './ProfileCredentialsInputRow';
import ProfileLinksInputRow from './ProfileLinksInputRow';
import { validator } from './validation';

const setInitialState = profile => {
  const { name, description, links } = profile;

  const linksCopy = cloneDeep(links);

  return {
    name,
    description: description || '',
    links: linksCopy || [],
  };
};

const EditBasicInformation = props => {
  const { profile, renderCredentialWithModal } = props;

  const dispatch = useDispatch();

  const initalState = setInitialState(profile);
  const formik = useFormik({
    initialValues: initalState,
    validate: validator,
    onSubmit: values => {
      dispatch(updateUserProfile(values));
    },
  });

  const { errors, values, isSubmitting } = formik;

  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="flex lg:flex-row flex-col gap-4 lg:justify-between justify-start w-full">
        <div className="flex mt-2.5 lg:w-[130px] items-center gap-4">
          <p className="text-sm font-bold">Name</p>
        </div>
        <div className="flex flex-col gap-1 w-full">
          <Input
            width="100%"
            name="name"
            error={!!errors.name}
            value={values.name}
            onChange={formik.handleChange}
          />
          {!!errors.name && (
            <p className="text-xs text-red-500">{errors.name}</p>
          )}
        </div>
      </div>
      <div className="flex lg:flex-row flex-col gap-4 lg:justify-between justify-start w-full">
        <div className="flex mt-4 lg:w-[130px] items-center gap-4">
          <p className="text-sm font-bold">About Me</p>
        </div>
        <div className="flex flex-col gap-1 w-full">
          <TextArea
            name="description"
            value={values.description}
            onChange={formik.handleChange}
          />
          {!!errors.description && (
            <p className="text-xs text-red-500">{errors.description}</p>
          )}
        </div>
      </div>
      <ProfileCredentialsInputRow
        credentials={profile.credentials}
        renderCredentialWithModal={renderCredentialWithModal}
      />
      <ProfileLinksInputRow
        onChange={links => formik.setFieldValue('links', links)}
        links={values.links}
      />
      <Button onClick={() => formik.handleSubmit()} isLoading={isSubmitting}>
        Save
      </Button>
    </div>
  );
};

export default EditBasicInformation;
